import loc from 'owa-localize';
import { observer } from 'mobx-react';

import * as React from 'react';
import {
    OptionQuickComponentSettings,
    OptionQuickToggleProps,
    OptionQuickCustomRenderProps,
    QuickSettingTooltip,
} from 'owa-options-core';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import { ControlIcons } from 'owa-control-icons';
import onQuickOptionToggle from 'owa-options-actions/lib/onQuickOptionToggle';

const styles = require('./QuickOptions.scss');

export interface QuickOptionEntryProps {
    onDismiss?: () => void;
    optionKey: string;
    quickOptionSetting: OptionQuickComponentSettings;
    titleStringKey: string;
}

@observer
export default class QuickOptionEntry extends React.Component<QuickOptionEntryProps, {}> {
    render() {
        const { optionKey, quickOptionSetting, titleStringKey } = this.props;
        const optionAriaId = `options-quick-${optionKey}`;
        const optionTooltipId = `${optionAriaId}-tooltip`;

        const { rendering, tooltip } = quickOptionSetting;
        let { tooltipStringKey, shouldHideTooltip } =
            tooltip || ({} as Partial<QuickSettingTooltip>);
        const { render } = rendering as OptionQuickCustomRenderProps;
        const {
            isToggleOn,
            onToggle,
            hideToggle,
            isDisabled,
        } = rendering as OptionQuickToggleProps;

        if (typeof tooltipStringKey === 'function') {
            tooltipStringKey = tooltipStringKey();
        }

        return (
            <div className={styles.quickSetting}>
                <div
                    id={optionAriaId}
                    className={styles.quickSettingHeader}
                    role="heading"
                    aria-level={3}>
                    <div className={styles.title}>
                        <span>{loc(titleStringKey)}</span>
                        {tooltip && (!shouldHideTooltip || !shouldHideTooltip()) && (
                            <TooltipHost
                                content={loc(tooltipStringKey) as string}
                                id={optionTooltipId}>
                                <Icon iconName={ControlIcons.Info} className={styles.infoIcon} />
                            </TooltipHost>
                        )}
                    </div>
                    {isToggleOn && onToggle && (!hideToggle || !hideToggle()) && (
                        <Toggle
                            checked={isToggleOn()}
                            onChanged={this.onToggle}
                            className={styles.toggle}
                            disabled={isDisabled && isDisabled()}
                            ariaLabel={loc(titleStringKey)}
                        />
                    )}
                </div>
                {render &&
                    render({
                        headerAriaId: optionAriaId,
                    })}
            </div>
        );
    }

    private onToggle = (isToggledOn: boolean) => {
        onQuickOptionToggle(isToggledOn, this.props.quickOptionSetting, this.props.optionKey);
    };
}
